import type { BusinessUnitAd, BusinessUnitAdUpdate } from 'services/types/businessUnitAd';

import baseApi from './baseApi';

const businessUnitAdsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllBusinessUnitAds: build.query<BusinessUnitAd[], number>({
      query: (businessUnitId) => ({
        url: `/admin/businessUnitAds/all?businessUnitId=${businessUnitId}`,
        method: 'GET',
      }),
    }),
    updateBusinessUnitAd: build.mutation<BusinessUnitAd, BusinessUnitAdUpdate>({
      query: (data) => ({
        url: `/admin/businessUnitAds/${data.id}`,
        method: 'PATCH',
        body: { ...data, id: undefined },
      }),
    }),
    deleteBusinessUnitAd: build.mutation<{ status: string }, number>({
      query: (id) => ({
        url: `/admin/businessUnitAds/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllBusinessUnitAdsQuery, useUpdateBusinessUnitAdMutation, useDeleteBusinessUnitAdMutation } =
  businessUnitAdsApi;
